import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
// import { Button } from "react-bootstrap";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import PaymentLinkForm from "./PaymentLinkForm";
import FetchUserDetails from "./FetchUserDetails";
import { fetchUserDetailsByMobileData } from "../../redux/reducers/apiSlice";
import { toast } from "react-toastify";
import { registerUser } from "../../redux/reducers/postApiSlice";
import { validatemap_form_email } from "../../exports/Validations";
import { selectAuth } from "../auth/auth.selector";
import CommonStructured from "../common-components/CommonStructured";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { fetchFDDPaymentLinkAccessData } from "../../redux/prospect-reducers/prospectSlice";

const PaymentLinkStructure = ({ callFunction }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { userDetailsByMobile } = useSelector((state) => state.api);
  const { fdPaymentLinkAccess } = useSelector((state) => state.prospects);

  const initialUserFormData = {
    mobile: "",
    email: "",
    name: "",
    gender: "",
    user_id: "",
    dob: "",
  };
  const [userFormData, setUserFormData] = useState(initialUserFormData);
  const [showUserInfoForm, setShowUserInfoForm] = useState(false);
  const [isUserExist, setIsUserExist] = useState(false);
  // const [isEmailValid, setIsEmailValid] = useState(false);
  const [canCallRegister, setCanCallRegister] = useState(false);
  const [newmail, setNewEmail] = useState(false);
  const [isFetchUserDetaillsByMobile, setIsFetchUserDetaillsByMobile] =
    useState(false);
  const [paymentFormModal, setPaymentFormModal] = useState(false);

  const isAdmin = decryptedText?.account_type === "admin";

  function getFDPaymentsAccessData() {
    dispatch(
      fetchFDDPaymentLinkAccessData({
        user_id: decryptedText?.uid || decryptedText?.user_id || "",
        filters: {},
        token: decryptedText?.token,
      })
    );
  }

  const onClickFetchUserDetails = () => {
    const handleConfirm = () => {
      if (userFormData.mobile && userFormData.mobile?.length === 10) {
        dispatch(
          fetchUserDetailsByMobileData({
            userMobile: userFormData.mobile,
            token: decryptedText?.token,
          })
        );
        setIsFetchUserDetaillsByMobile(true);
      } else {
        toast.error("Please Enter Mobile Number! (Number Must Be 10 Digit)");
        setIsFetchUserDetaillsByMobile(false);
      }
    };

    showConfirmAlert(
      handleConfirm,
      `Is the entered ${userFormData.mobile} number correct?`
    );
  };

  const onClickRegisterUser = () => {
    if (
      !userFormData.mobile ||
      !userFormData.email ||
      !userFormData.name ||
      !userFormData.gender?.value
    ) {
      toast.error("Please Ensure All The Fields Are Filled!");
    } else if (!validatemap_form_email(userFormData.email)) {
      toast.error("Please Enter Correct Format of Email!");
    } else if (userFormData.mobile?.length !== 10) {
      toast.error("Please Enter Correct Format of Mobile Number!");
    } else {
      setCanCallRegister(true);
    }
  };

  function handleBack() {
    setUserFormData(initialUserFormData);
    setIsUserExist(false);
    setIsFetchUserDetaillsByMobile(false);
  }

  const handleRegisterUser = async (userData, TOKEN) => {
    setCanCallRegister(false);

    try {
      const actionResult = dispatch(registerUser({ userData, TOKEN }));
      const result = await actionResult;

      console.log("result=> ", result);

      if (result?.payload?.status && result?.payload?.data) {
        // if (result.payload?.data) {
        //   setUserFormData({
        //     mobile: result.payload.data?.mobile,
        //     email: result.payload.data?.email,
        //     name: result.payload.data?.name,
        //     user_id: result.payload.data?.user_id,
        //   });
        // }
        setUserFormData({
          mobile: result.payload.data?.mobile,
          email: result.payload.data?.email,
          name: result.payload.data?.name,
          user_id: result.payload.data?.user_id,
          gym_id: result.payload.data?.gym_id,
          gym_name: result.payload.data?.gym_name,
        });
        // toast.success(result.payload.message);
        setPaymentFormModal(true);
        setShowUserInfoForm(false);
        setIsUserExist(false);
        setNewEmail(false);
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage);
        // console.log("errorMessage=> ", errorMessage);
      }
    } catch (error) {
      console.log("handleRegisterUser ERROR => ", error);
    }
  };

  useEffect(() => {
    if (!isAdmin && (decryptedText?.uid || decryptedText?.user_id)) {
      getFDPaymentsAccessData();
    }
  }, []);

  useEffect(() => {
    if (isFetchUserDetaillsByMobile && userDetailsByMobile?.status) {
      const { uid, name, email, gym_id, gym_name, dob, account_type } =
        userDetailsByMobile?.data?.[0];

      if (account_type !== "member") {
        toast.error("Enter Member Mobile Number!");
        return;
      } else if (!validatemap_form_email(email)) {
        setNewEmail(true);
        toast.error("Member Email Is Not Valid! Please Update Email.");
        return;
      } else {
        setUserFormData({
          ...userFormData,
          name: name,
          email: email,
          gym_id: gym_id,
          gym_name: gym_name,
          user_id: uid,
          dob: dob,
        });
        setPaymentFormModal(true);
        setNewEmail(false);
        setShowUserInfoForm(false);
        setIsUserExist(false);
        setCanCallRegister(false);
      }
    } else if (
      isFetchUserDetaillsByMobile &&
      userDetailsByMobile?.status === false
    ) {
      setIsUserExist(true);
      toast.error(userDetailsByMobile?.message);
    }
  }, [userDetailsByMobile]);

  useEffect(() => {
    if (canCallRegister) {
      setCanCallRegister(false);
      // setUserFormData(initialUserFormData);

      const userData = {
        name: userFormData.name,
        mobile: userFormData.mobile,
        email: userFormData?.email,
        gender: userFormData.gender?.value,
        dob: userFormData.dob || "",

        is_web: 1,
        account_type: "member",
        otp: "otp",
        referral_code: "",
        n_token: "n_token",
      };

      handleRegisterUser(userData, decryptedText?.token);
    }
  }, [userFormData, canCallRegister]);

  useEffect(() => {
    if (paymentFormModal) {
      setShowUserInfoForm(false);
    }

    if (!showUserInfoForm && !paymentFormModal) {
      setUserFormData(initialUserFormData);
    }
  }, [paymentFormModal, showUserInfoForm]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <>
      <Modal
        isOpen={paymentFormModal}
        onRequestClose={() => {
          setPaymentFormModal(false);
          setUserFormData(initialUserFormData);
        }}
        contentLabel="Payment Link Modal"
        ariaHideApp={false}>
        <div className="createNewCTOModalContainer sendRenewalPaymentLinkModalContainer">
          <ModalHeadAndClose
            title="Create Payment Link"
            onClose={() => {
              setPaymentFormModal(false);
              setUserFormData(initialUserFormData);
            }}
          />

          <PaymentLinkForm
            paymentLinkData={userFormData}
            closeModal={() => {
              setUserFormData(initialUserFormData);
              setPaymentFormModal(false);
            }}
            callFunction={callFunction}
          />
        </div>
      </Modal>

      <CommonStructured
        pageHeading={"One Time Payment Link"}
        // createBtnTxt={
        //   isAdmin || fdPaymentLinkAccess ? "Create Payment Link" : null
        // }
        // onClickCreateBtn={() =>
        //   isAdmin || fdPaymentLinkAccess ? setShowUserInfoForm(true) : null
        // }
        isReload={callFunction}
      />

      {showUserInfoForm && (
        <FetchUserDetails
          isUserExist={isUserExist}
          userFormData={userFormData}
          setUserFormData={setUserFormData}
          onClickFetchUserDetails={onClickFetchUserDetails}
          onClickRegisterUser={onClickRegisterUser}
          handleBack={handleBack}
        />
      )}

      <>
        {/* <div className="mainContainer">
        <div className="innerContainer">
          <div className="globalGymANdDatesFilterContainer globalGymANdDatesFilterContainerWithM0">
            <div className="renewal-header-gym flexBetween">
              <div className="">
                <span className="fs-lg-k">Payment Link</span>
              </div>
              <div className="lastFlex">
                <div className="columsDivsFlexEndFilterContainer gap-2">
                  <Button
                    variant="danger"
                    className="notmalButtonStyles"
                    onClick={() => setShowUserInfoForm(true)}
                  >
                    Create New Payment Link
                  </Button>
                  <Button
                    variant="outline-danger"
                    className="notmalButtonStyles"
                    onClick={onClickReset}
                  >
                    Reset filter
                  </Button>
                </div>
              </div>
            </div>

            {showUserInfoForm && (
              <FetchUserDetails
                isUserExist={isUserExist}
                userFormData={userFormData}
                setUserFormData={setUserFormData}
                onClickFetchUserDetails={onClickFetchUserDetails}
                onClickRegisterUser={onClickRegisterUser}
              />
            )}
          </div>
        </div>
      </div> */}
      </>
    </>
  );
};

export default PaymentLinkStructure;
